module.exports = __webpack_public_path__ + "img/kin6.a81e93b9.jpg";